export default function truncateString(str, num) {
	if (!str) {
		return "";
	}

	if (str.length <= num) {
		return str;
	}

	return str.slice(0, num) + "...";
}

export function truncateMiddle(str, num = 5) {
	return str.length <= num * 2 + 3 ? str : str.slice(0, num) + "..." + str.slice(-num);
}
